// src/App.js

import React, { useState } from "react";
import { Header, Footer, BackToTop, MobileBar } from "./components/Chrome";
import { ColdChain } from "./components/Effects";
import { Hero, Equipment, Why, Contracts, Coverage } from "./components/Sections";
import Triage from "./components/Triage";
import Gallery from "./components/Gallery";
import EnquiryForm from "./components/EnquiryForm";

export default function App() {
  // Set by the triage tool, consumed once by the enquiry form. Held here
  // rather than in a context because it is one value passed between two
  // siblings.
  const [brief, setBrief] = useState(null);

  return (
    <>
      <Header />
      <ColdChain />
      <main>
        <Hero />
        <Equipment />
        <Triage onUseReport={setBrief} />
        <Why />
        <Gallery />
        <Contracts />
        <Coverage />
        <EnquiryForm brief={brief} />
      </main>
      <Footer />
      <BackToTop />
      <MobileBar />
    </>
  );
}